import { googleFetch } from '../client';

export interface GoogleDriveRootFolder {
  id: string;
  name: string;
  parents?: string[];
  mimeType?: string;
}

export type GoogleDriveRootFolderScope = 'my_drive' | 'shared_drive';

export type GoogleDriveRootFoldersListParams =
  | {
      scope: 'my_drive';
    }
  | {
      scope: 'shared_drive';
      shared_drive_id: string;
      supports_all_drives?: boolean;
    };

export interface GoogleDriveRootFoldersListResponse {
  folders: GoogleDriveRootFolder[];
}

export async function googleDriveRootFoldersList(
  params: GoogleDriveRootFoldersListParams
): Promise<GoogleDriveRootFoldersListResponse> {
  return googleFetch<GoogleDriveRootFoldersListResponse>(
    '/rpc/google_drive_root_folders_list',
    {
      body: params,
    }
  );
}
